import { createLogic } from 'redux-logic'
import { map } from 'rxjs/operators'
import * as constants from '../constants'

export const getUsers = createLogic({
    type: constants.GET_USERS.ACTION,
    processOptions: {
        successType: constants.GET_USERS.FULFILLED,
        failType: constants.GET_USERS.REJECTED
    },
    process({ http, action }) {
        return http
            .post('/comps/users', action.payload)
            .pipe(
                map(http.getBody)
            )
    }
})
